import React from 'react';
import './App.css';
import StockAbout from './components/stockAbout';
import StockContact from './components/stockContact';
import StockFooter from './components/stockFooter';
import StockHome from './components/stockHome';
import StockNavbar from './components/stockNavbar';
import StockOffer from './components/stockOffer';
import StockPricing from './components/stockPricing';

function App() {
  return (<React.Fragment>
      <StockNavbar/>
      <div className="App">
        <StockHome/>
        <StockAbout />
        <StockOffer/>
        <StockPricing/>
        <StockContact/>
        <StockFooter/>
        <div id="pageup">
        <a href="#home">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-up-circle"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
            />
          </svg>
        </a>
      </div>
      </div>
    </React.Fragment>
  );
}

export default App;
